<template >
    <div id="tree-map" :class="{ active_tree_map: ready, loader_tree_map: !ready}" v-if="show && show_inner">
        <template v-if="!ready">
                <Loader class="half_opacity"/>
        </template>
        <template v-if="ready">
            <GChart
                :settings="{packages: ['corechart','table','treemap']}"
                :data="treeData"
                :options="chartOptions"
                :events="chartEvents"
                :class="{ ready: ready_map, loading: !ready_map}"
                type="TreeMap"
                id="tree_map_chart"
                ref="gChart"
                />
        </template>
    </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import formattersMixin from "@/plugins/formattersMixin.js";
import { GChart } from 'vue-google-charts';

export default {
    name:"tree-map",
    props: {
        version: { required: true },
        hash: { required: true },
        type: { required: true },
        order: { type: Object,required: true },
        title: { type: String,required: true },
        count: { type: Number,required: false, default:100 },
        show: { required: false, default: true },
        filter: { required: false, default: {} },
        url_type: { required: false }
    },
    components: { Loader, GChart },
    mixins: [formattersMixin],
    data () {
        return {
            sorted:false,
            treeData:[],
            originalData:[],
            ready:false,
            ready_map:false,
            show_inner:true,
            sortDataF:this.sortData(),
            chartOptions: {
                noColor:'#c7c7c7',
                minColor: '#f8e71c',
                midColor:'#f5a623',
                maxColor: '#ff2700',
                fontFamily:"Inter",
                headerHeight: 15,
                fontColor: 'black',
                fontWeight: 'bold',
                height: 500,
                onmouseover: this.redirect,
                generateTooltip:this.toolTip,
                eventConfig:{
                    onmouseover: this.redirect
                }

            },
            chartEvents: {
                select: () => {
                    const selection = getSelection();
                    var slug = "";
                    var name = ""
                    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                    if (isSafari) {
                        name = selection.focusNode.innerText;
                        if (name) {
                            name = name.trim()
                        }
                    }
                    else {
                        name = selection.focusNode.nodeValue;
                        if (name) {
                            name = name.trim()
                        }
                    }
                    this.originalData.forEach(function(item){
                        if (item.name == name) {
                            slug = item.slug;
                        }
                    });
                    console.log(this.originalData, slug, name, selection, selection.focusNode.innerText, selection.focusNode.nodeValue)
                    var url_type = this.url_type != null ? this.url_type : this.type;
                    this.$router.push("/"+this.version+"/"+this.hash+"/"+url_type+"/"+slug);
                }
            }
        }
    },
    watch:{
        order: function(){
            this.refresh();
        },
        originalData: function(array){
            if(array.length==0){
                this.show_inner=false;
                this.ready=false;
                this.ready_map=false;
            }
        }
    },
    methods: {
        sleep: function(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        redirect: function(slug){
            this.$router.push("/"+this.version+"/"+this.hash+"/"+this.type+"/"+slug);
        },
        sortData: function() {
            this.ready_map=false;
            this.ready=false;
            var count_rows = 0;
            var treeData=[];


            var used={"titles":[]}
            this.treeMap().then((value) => {

            this.originalData=value;
            var self=this;

            var header=["Zakázka","Rodič","Objem","Risk"];
            treeData.push(header);
            var typ='Top '+value.length+' '+this.title;
            treeData.push([typ,null,0,0]);

            // For correct color display
            treeData.push(['červená',typ,0.0000000000000000000000000000000000001,1]);
            treeData.push(['oranžová',typ,0.0000000000000000000000000000000000001,0]);
            treeData.push(['žlutá',typ,0.0000000000000000000000000000000000001,-1]);
            var originalNames = this.setNames(value);
            originalNames.forEach(function(item){
                if(!used["titles"].includes(item.name)){
                    var risk=null;
                    if(self.version=="full"){
                        if(item.risk_level_full == "no"){
                            risk=null;
                        }
                        else if (item.risk_level_full == "low"){
                            risk=-1;
                        }
                        else if(item.risk_level_full == "medium"){
                            risk=0;
                        }
                        else{
                            risk=1;
                        }
                    }
                    else{
                        if(item.risk_level_lite == "no"){
                            risk=null;
                        }
                        else if (item.risk_level_lite == "low"){
                            risk=-1;
                        }
                        else if(item.risk_level_lite == "medium"){
                            risk=0;
                        }
                        else{
                            risk=1;
                        }
                    }
                    if(item.price != null && item.price > 100){
                        treeData.push([item.name,typ,parseInt(item.price),risk]);
                        used["titles"].push(item.name);
                        count_rows++;
                    }
                }
            });
            if(count_rows == 0){
                this.show_inner=false;
                this.ready=false;
                this.ready_map=false;
            }
            else{
                this.show_inner=true;
                this.treeData=treeData;
                this.ready=true;
                this.sleep(1000).then(()=>{
                this.ready_map=true;
            });
            }

            });
        },
         refresh: function() {
            this.sortData();
        },
        treeMap: function() {
            var sign=this.order.value.desc?"-":"";
            var order_by=sign+this.order.value.by;
            var params={"format":"json","page":0,"page_size":this.count,"order_by":order_by,"treemap":true}
            params[`${this.version}_hash`] = this.hash;

            if (this.filter.risk) {
                var risks = "";
                var levels = ["high", "medium", "low", "no_risk"];
                levels.forEach((n) => {
                    if (this.filter.risk.indexOf(n) >= 0) {
                        if(risks != ""){
                            risks += ",";
                        }
                        risks += n;
                    }
                });
                if(risks.length > 0) {
                    var risk = {"risks": risks};
                    params = { ...params, ...risk };
                }
            }
            if(this.filter.q){
                params = { ...params, ...{q:this.filter.q} };
            }

            if (this.filter.flag && this.filter.flag.length) {
                params = {
                    ...params,
                    ...{ flag: this.filter.flag.map((f) => f.name).join(",") }
                };
            }
            if (this.filter.year && this.filter.year.length) {
                params = { ...params, ...{ year: this.filter.year.join(",") } };
            }
            return this.$store.getters.api
                .get(this.type+"/", { params: params })
                .then((response) => {
                    return response.data.data;
                })
                .catch((e) => {
                    console.dir(e);
                    return [];
                });
        },
        toolTip: function(row, size) {
            if(row > 3){
                var price = this.$filters.price(size) ;
                var string = "";
                if(this.type == 'tender' || this.type == 'contract'){
                    string = 'Cena: ';
                }
                else{
                    if(this.version == "lite"){
                        string = 'Zadáno v Kč: ';
                    }
                    else{
                        string = 'Zaplaceno v Kč: ';
                    }
                }
                var name = "";
                var nameTreeData = this.treeData[row+1][0];
                this.originalData.forEach(function(item){
                    if(item.name == nameTreeData){
                        name = item.title;
                    }
                });
                return '<div class="tooltip_random_name">'
                    + name + '<br>'
                    + string + price + '<br>'
                    + 'Výše rizika: ' + (this.originalData[row-4].risk * 100).toFixed(2) + ' %<br>'
                    + '</div>';
            }
            else{
                return '';
            }
        },
        setNames: function(values){
            var list = [];
            var final_list = [];
            for(var i=0; i<values.length; i++){
                var el = null;
                if(list.length){
                    el = list.find((x)=> Object.keys(x)[0] == values[i].title);
                    if(el == undefined){
                        el = null;
                    }
                }
                if(el != null && list.includes(el)){
                    el[values[i].title].push(i);
                }
                else{
                    var dict = {};
                    dict[values[i].title] = [i];
                    list.push(dict);
                }
            }
            for(var k=0; k< list.length; k++){
                for(const key in list[k]){
                    var delka = list[k][key].length;
                    if(delka == 1){
                        values[list[k][key][0]]["name"] = key;
                        final_list.push(values[list[k][key][0]]);
                    }
                    else{
                        var duplicates = [];
                        for(var j = 0; j < delka; j++){
                            var string = "";
                            if(this.type=='tender' || this.type=='contract'){
                                string="id: "+values[list[k][key][j]].id;
                            }
                            else{
                                string="IČO: "+values[list[k][key][j]].ico;
                            }
                            values[list[k][key][j]]["name"] = key + " ("+string+")";
                            final_list.push(values[list[k][key][j]]);
                            duplicates.push(values[list[k][key][j]]);
                        }
                    }
                }
            }
            return final_list;
        }
    }
}
</script>

<style lang="scss">
@use "@/scss/custom";
@use "@/scss/utils";
.tooltip_random_name{
    background-color: custom.$background-light;
    border: 1px solid custom.$table-border-color;
    padding:10px
}

#tree-map.active_tree_map{
    width:100%;
    height:500px;
    margin: 10px 0;
    transition: 1s;
    text-align:right;
    #tree_map_chart.ready{
        opacity:1;
        transition: 0.5s;
    }
    #tree_map_chart.loading{
        opacity: 0;
        transition: 0.5s;
    }
}

#tree-map.loader_tree_map{
    width:100%;
    height:100px;
    margin: 10px 0;
    transition: 1s;
}

.half_opacity{
    opacity:0.5;
}

#tree-map svg {
    position: relative;
    left: -6px;
    margin: auto;
}

#tree-map rect {
  stroke: rgb(63, 63, 63);
  stroke-width: 1;
}

#tree-map svg g {
    cursor: pointer !important;
}
</style>
